export default "__VITE_ASSET__BQ6GBoQi__"